import type { ImageElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'
import { FileUsageSource } from '@vedalib/editor/lib/files'

import { DEMO_MODE } from 'services/Store/Project/constants'

import DemoWrapper from '../../decorators/DemoWrapper'
import Element from './ImageElement'
import imageDemo from './assets/imageDemo.svg'
import type { ImageDemoType } from './imageTypes'

const DEMO_VALUE: ImageElementValue = {
  image: {
    source: FileUsageSource.url,
    id: 'demo',
    url: imageDemo,
  },
  overlay: null,
}

const ImageDemo: ImageDemoType = ({ styles, feedback }) => {
  return (
    <DemoWrapper center full>
      <Element
        element={{
          id: `${CONFIG_ELEMENTS.image.type}-demo`,
          type: CONFIG_ELEMENTS.image.type,
          value: DEMO_VALUE,
          style: {},
          font: {},
          feedback: {},
        }}
        feedback={feedback}
        font={{}}
        mode={DEMO_MODE}
        styles={{ ...styles, root: { ...styles.root, padding: 200 } }} // rude hack to make image bigger
      />
    </DemoWrapper>
  )
}

export default ImageDemo
